/* eslint no-use-before-define: "error"*/
import React, {
    useState, useContext, useCallback
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import {
    ViewModelServiceContext,
    withViewModelService,
    ViewModelForm
} from '@xengage/gw-portals-viewmodel-react';
import { UserService, PolicyService } from 'gw-capability-gateway';
import { FormModalPopover } from 'ml-components-platform-react';
import { AccountService } from 'gw-capability-gateway-account';
import { useTranslator } from '@jutro/locale';
import { MLTagManagerService } from 'ml-portals-services-react'
import mlNoteDetailPopupMsg from '../MLNoteDetailPopup/MLNoteDetailPopup.messages';
import mlNoteDetailPopupMetadata from '../MLNoteDetailPopup/MLNoteDetailPopup.metadata.json5';
import mlNoteDetailReadOnlyMetadata from '../MLNoteDetailPopup/MLNoteDetailReadOnlyPopup.metadata.json5';
import mlNoteDetailPopupStyle from '../MLNoteDetailPopup/MLNoteDetailPopup.module.scss';
import metadata from './MLHistoryNotesComponent.metadata.json5';
import messages from './MLHistoryNotesComponent.messages';
import styles from './MLHistoryNotesComponent.module.scss';

import { Button } from '@jutro/legacy/components';

const MLHistoryNotesComponent = (props) => {
    const modalApi = useModal();
    const {
        authHeader,
        historyNotes,
        accountNumber,
        policyNumber,
        onAddNote
    } = props;
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const [notesSubmissionVM, updateNotesSubmissionVM] = useState({});

    const { onValidate } = useValidation('MLHistoryNotesComponent');
    const [showNotesOnly, UpdateShowNotesonly] = useState(true)

    const writeValue = useCallback(
        (value, path) => {
            const newNotesSubmissionVM = viewModelService.clone(notesSubmissionVM);
            _.set(newNotesSubmissionVM, path, value);
            updateNotesSubmissionVM(newNotesSubmissionVM);
        },
        [notesSubmissionVM, viewModelService]
    );
    const openAddNoteDialog = (noteVM) => {
        MLTagManagerService.sendFormCompleteEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add Note`);

        const addNote = async () => {
            let isNotCreated;
            if (policyNumber) {
                isNotCreated = await PolicyService.createNoteForPolicy(
                    [policyNumber, noteVM.value],
                    authHeader
                )
            } else {
                isNotCreated = await AccountService.createNoteForAccount(accountNumber, noteVM.value, authHeader)
            }

            if (isNotCreated) {
                MLTagManagerService.sendFormCompleteEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add Note`);
                onAddNote();
            }
        };

        const componentProps = {
            title: mlNoteDetailPopupMsg.addNote,
            uiProps: mlNoteDetailPopupMetadata.componentContent,
            actionBtnLabel: _.upperCase(translator(mlNoteDetailPopupMsg.addNote)),
            cancelBtnLabel: mlNoteDetailPopupMsg.cancelModal,
            disableButton: (vm) => !(_.get(vm, 'aspects.valid') && vm, _.get(vm, 'aspects.subtreeValid')),
            viewModel: noteVM,
            modalBodyStyles: mlNoteDetailPopupStyle,
            getOverrideProps: () => {
                return {
                    policyAccountNumber: {
                        label: policyNumber ? translator(mlNoteDetailPopupMsg.policyNumber) : translator(mlNoteDetailPopupMsg.accountNumber),
                        value: policyNumber || accountNumber
                    },
                    category: {
                        value: "Agent"
                    }
                }
            },
            onSaveAction: () => {
                addNote();
                return true;
            },
            buttonType: ''
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }

    const onAddANoteClicked = async () => {
        const note = {
            createdDate: new Date(), // Today
            topic: 'agent_ext'
        };
        const userResp = await UserService.getCurrentUser(authHeader)
        note.authorName = userResp.displayName;
        const noteVM = viewModelService.create(note, 'pc', 'edge.capabilities.gateway.note.dto.NoteDTO');
        openAddNoteDialog(noteVM);

    };

    const openReadonlyNoteDialog = (note) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Note Details`);
        const noteVM = viewModelService.create(note.note, 'pc', 'edge.capabilities.gateway.note.dto.NoteDTO');
        const componentProps = {
            title: mlNoteDetailPopupMsg.noteDetails,
            uiProps: mlNoteDetailReadOnlyMetadata.componentContent,
            modalBodyStyles: mlNoteDetailPopupStyle,
            cancelBtnLabel: mlNoteDetailPopupMsg.closeBtnLabel,
            viewModel: noteVM,
            showActionButton: false,
            getOverrideProps: () => {
                return {
                    policyAccountNumber: {
                        label: policyNumber ? translator(mlNoteDetailPopupMsg.policyNumber) : translator(mlNoteDetailPopupMsg.accountNumber),
                        value: policyNumber || accountNumber
                    }
                }
            },
            buttonType: 'secondary'
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );

    }


    const getNumberDisplayableNotes = () => {
        if (!historyNotes) {
            return 0;
        }
        return showNotesOnly ? historyNotes.filter((note) => note.isNote).length : historyNotes.length;
    };

    const showNoNotesMessage = () => {
        return (!historyNotes || historyNotes.length === 0) || (getNumberDisplayableNotes() < 1 && showNotesOnly);
    };

    const getCategoryValue = (note) => {
        return (
            <Button onClick={() => openReadonlyNoteDialog(note)} type="text">{note.categoryDescription.category}</Button>
        )
    };

    const getPolicyNumberValue = (number) => {
        if (!number) {
            return <span>Account</span>;
        }

        return <Link to={`/policies/${number}/summary`}>{number}</Link>
    }

    const generateNotesListOverrides = () => {
        const overrides = historyNotes.map((note, index) => {
            return {
                [`dateRow${index}`]: {
                    content: moment(note.date).format('MM/DD/YYYY')
                },
                [`policyNumberRow${index}`]: {
                    visible: !!accountNumber,
                    content: getPolicyNumberValue(note.policyNumber),
                },
                [`categoryRow${index}`]: {
                    content: getCategoryValue(note)
                },
                [`fulldescriptionTooltip${index}`]: {
                    content: note.note.body
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const toggleNotesOnly = () => {
        UpdateShowNotesonly(!showNotesOnly);
    };

    const isNoNotes = showNoNotesMessage();

    const overrideProps = {
        noteTableScrollableContainer: {
            visible: !isNoNotes,
        },
        notesTableRowIterable: {
            data: historyNotes
        },
        historyContainer: {
            visible: !isNoNotes,
            content: (
                <a onClick={() => toggleNotesOnly()}>
                    {showNotesOnly ?

                        (
                            <div>
                                <span>{translator(messages.showHistory)}</span>
                                <i className="icon-ml-carrot-down-outline" />
                            </div>
                        )
                        :
                        (
                            <div>
                                <span>{translator(messages.hideHistory)}</span>
                                <i className="icon-ml-carrot-down-outline icon-rotate-180" />
                            </div>
                        )
                    }
                </a>

            )
        },
        policyNumberHeader: {
            visible: !!accountNumber,
        },
        noNotesMessage: {
            visible: isNoNotes,
            content: `${translator(messages.noNotes)} ${accountNumber? "account" : "policy"}`
        },
        ...generateNotesListOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onClickAddNote: onAddANoteClicked,
            openReadonlyNoteDialog : openReadonlyNoteDialog
        }
    };
    const readValue = (id, path) => {
        return readViewModelValue(
            metadata.componentContent,
            notesSubmissionVM,
            id,
            path,
            overrideProps
        );
    };
    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={notesSubmissionVM}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            resolveValue={readValue}
            onValidationChange={onValidate}
        />
    );
};

MLHistoryNotesComponent.propTypes = {
    authHeader: PropTypes.shape({
        Authorization: PropTypes.string
    }).isRequired,
    historyNotes: PropTypes.arrayOf(
        PropTypes.shape({})
    ).isRequired,
    accountNumber: PropTypes.string,
    policyNumber: PropTypes.string,
    onAddNote: PropTypes.shape({})


};
export default withRouter(withViewModelService(MLHistoryNotesComponent));
